import React from 'react'
//import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import Tool from './Tool.jsx'

const divStyle = {
  paddingTop: '150px',
}

const MainDiv = props => <div className="row justify-content-center align-items-center" style={divStyle}><Tool link="/employees" name="Employee" icon="users"></Tool><Tool link={props.user} name="Accounting" icon="clipboard"></Tool><Tool link="https://www.mes-apps.com" target="_blank" name="Bugs Scheduler" icon="calendar"></Tool></div>

MainDiv.propTypes = {
  user: PropTypes.string,
}

export default MainDiv
